/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Green_Lion_BiteInputs */

const en_shy_green_lion_bite = /** @type {(inputs: Shy_Green_Lion_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic classification`)
};

const de_shy_green_lion_bite = /** @type {(inputs: Shy_Green_Lion_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themenklassifizierung`)
};

/**
* | output |
* | --- |
* | "Topic classification" |
*
* @param {Shy_Green_Lion_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_green_lion_bite = /** @type {((inputs?: Shy_Green_Lion_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Green_Lion_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_green_lion_bite(inputs)
	return de_shy_green_lion_bite(inputs)
});